import { render, staticRenderFns } from "./hotSpot.vue?vue&type=template&id=0c9a9ae0&scoped=true"
import script from "./hotSpot.vue?vue&type=script&lang=js"
export * from "./hotSpot.vue?vue&type=script&lang=js"
import style0 from "./hotSpot.vue?vue&type=style&index=0&id=0c9a9ae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9a9ae0",
  null
  
)

export default component.exports